import { H2 } from "@/components/ui/typography";
import { useAuth } from "@/features/auth/useAuth";
import { ROLE } from "@/utils/constant";
import { hasCommonElement } from "@/utils/helper/hasCommonElement";
import { Navigate } from "react-router-dom";

export default function Landing() {
  const auth = useAuth();
  const user = auth.getUser();

  if (!user) {
    console.error("User is not found.");
    return null;
  }

  if (
    hasCommonElement(user.roles, [
      ROLE.ADMINISTRATOR,
      ROLE.VALIDATOR_DOCUMENT_OFFICER,
      ROLE.REVISE_DOCUMENT_OFFICER,
      ROLE.MONITORING_TEAM,
      ROLE.VENDOR,
    ])
  ) {
    return <Navigate to="/dashboard/nro" replace />;
  }

  return (
    <H2>
      Welcome {user.firstName} {user.lastName}
    </H2>
  );
}
